<template>
  <zg-dialog
    v-if="value"
    :showHead="false"
    :showFoot="false"
    :class="dialogClass"
  >
    <div class="user-group-dialog-title" v-if="!overLimit">
      <span>新建用户群</span>
    </div>
    <div class="user-group-dialog-content" v-if="!overLimit">
      <group-editor @add="onCreateGroup" @cancel="onCancel"></group-editor>
    </div>
    <div class="user-group-over-limit" v-if="overLimit">
      <div v-html="overLimitHtml"></div>
      <div class="footer-btn">
        <zg-button size="normal" @click="onCancel">关闭</zg-button>
        <zg-button size="normal" type="primary" @click="guideToPro">
          {{ btnOkText }}
        </zg-button>
      </div>
    </div>
  </zg-dialog>
</template>

<script>
import GroupEditor from './groupEditor'
import { mapState } from 'vuex'
import { versionStr } from '../../constants'
export default {
  name: 'groupDialog',
  components: { GroupEditor },
  props: ['value'],
  data () {
    return {
      overLimitHtml: '',
      btnOkText: '我知道了'
    }
  },
  computed: {
    ...mapState({
      versionNum (state) {
        return state.bizSys.currentUser.version
      },
      groupLimit (state) {
        let currentUser = state.bizSys.currentUser
        let verStr = versionStr[this.versionNum]
        return currentUser.notes[verStr].user_group
      },
      groupList (state) {
        return state.bizUserGroup.list
      }
    }),
    overLimit () {
      return this.groupList.length >= this.groupLimit
    },
    dialogClass () {
      return {
        'user-group-dialog': true,
        'user-group-version-limit': this.overLimit
      }
    }
  },
  watch: {
    overLimit () {
      if (!this.overLimit) return
      if (this.versionNum === 1 || this.versionNum === 9) {
        // 基础版
        this.overLimitHtml =
          '<p>基础版每个应用最多创建' +
          this.groupLimit +
          '个用户群</p>' +
          '<p>您可以升级为专业版以创建更多，也可以删除不必要的用户群</p>' +
          '<br />' +
          '<p>- 联系我们 <span class="textcolor_blue" style="color:#00a2e6;">40080-94843</span></p>'
        this.btnOkText = '了解专业版'
        window.track('账号-收到基础版用户群超限提示', {
          appid: this.appId,
          platform: this.platform
        })
      }
      if (this.versionNum === 10) {
        // 专业版
        this.overLimitHtml =
          '<p>专业版每个应用最多创建' +
          this.groupLimit +
          '个用户群</p>' +
          '<br />' +
          '<p>- 联系我们 <span class="textcolor_blue" style="color:#00a2e6;">40080-94843</span></p>'
        this.btnOkText = '我知道了'
      }
    }
  },
  methods: {
    onCreateGroup (data) {
      this.$emit('create', data)
      this.$emit('input', false)
    },
    onCancel () {
      this.$emit('input', false)
    },
    guideToPro () {
      if (this.versionNum === 1 || this.versionNum === 9) {
        window.track('账号-收到基础版用户群超限提示-点击了解专业版')
        window.open('https://zhugeio.com/price/price.html')
        return
      }
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="sass">
@import "styles/groupDialog"
</style>
